














































































































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import TheFormAddressesCart from '../addresses/TheFormAddressesCart.vue';

export default {
    name: 'TheCartForm',
    components: {
        BaseButton,
        TheFormAddressesCart,
    },
    data() {
        return {
            donation: String(),
            promo: String(),
        };
    },
    props: {
        address: Object,
        addresses: Array,
        auth: Boolean,
        data: Object,
        errors: Array,
        gift: String,
        notes: String,
        selected_address: String,
    },
    computed: {
        price() {
            const final = this.data.hasOwnProperty('details') ? Number(this.data.details.subfinal_price) : 0;
            return Number(final).toFixed(2);
        },
        promoPrice() {
            if (!this.data.hasOwnProperty('details')) {
                return '';
            }
            return Number(this.data.details.final_price).toFixed(2);
        },
    },
};
